<template>
  <div class="logo">
    <div class="logo_mobile"></div>
    <div class="logo_desktop">
      <div class="flower_wrapper" ref="flower">
        <div class="el-wrapper">
          <div class="flower_2 second_animate"></div>
        </div>
      </div>
      <div class="elements" ref="elements">
        <div class="el-wrapper">
          <div class="element_1 second_animate"></div>
          <div class="element_2 third_animate"></div>
          <div class="element_3 third_animate"></div>
          <div class="element_4 third_animate"></div>
          <div class="element_5 third_variant_animate"></div>
          <div class="element_6 second_animate"></div>
        </div>
      </div>
      <div class="letters-logo" ref="letter2">
        <div class="el-wrapper">
          <div class="letters-logo_2 first_animate"></div>
        </div>
      </div>
      <div class="flower_wrapper" ref="flower_two">
        <div class="el-wrapper">
          <div class="flower_1 fourth_animate"></div>
        </div>
      </div>
      <div class="letters-logo" ref="letter1">
        <div class="el-wrapper">
          <div class="letters-logo_1 first_animate"></div>
        </div>
      </div>
      <div class="flower_wrapper" ref="elements1">
        <div class="el-wrapper">
          <div class="element_7 third_variant_animate"></div>
        </div>
      </div>

      <div class="leafs">
        <div class="leaf_wrapper leaf1_wrapper">
          <div class="el-wrapper" ref="leaf1">
            <div class="leaf_1 leaf_first"></div>
          </div>
        </div>
        <div class="leaf_wrapper leaf2_wrapper">
          <div class="el-wrapper" ref="leaf2">
            <div class="leaf_2 leaf_second"></div>
          </div>
        </div>
        <div class="leaf_wrapper leaf3_wrapper">
          <div class="el-wrapper" ref="leaf3">
            <div class="leaf_3 leaf_third"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 1423px * 709
// 640 * 426px
import { mapGetters } from 'vuex';

export default {

  computed: {
    ...mapGetters(['browser']),
  },

  mounted() {
    setTimeout(() => {
      this.animation();
    }, 0);
  },

  methods: {
    tilt() {
      const screenWidth = window.screen.width / 2;
      const screenHeight = window.screen.height / 2;
      const elem = this.$refs.letter1;
      const elem2 = this.$refs.letter2;
      let validPropertyPrefix = '';
      const otherProperty = 'perspective(1000px)';
      const elemStyle = elem.style;

      if (typeof elemStyle.webkitTransform === 'string') {
        validPropertyPrefix = 'webkitTransform';
      } else if (typeof elemStyle.MozTransform === 'string') {
        validPropertyPrefix = 'MozTransform';
      }
      document.addEventListener('mousemove', (e) => {
        const centroX = e.clientX - screenWidth;
        const centroY = screenHeight - (e.clientY + 13);
        const degX = centroX * 0.02;
        const degY = centroY * 0.01;
        const style = `${otherProperty} rotateY(${degX}deg) rotateX(${degY}deg)`;
        elem.style[validPropertyPrefix] = style;
        elem2.style[validPropertyPrefix] = style;
      });
    },

    parallax(elem, speed, direction) {
      let newSpeed = speed;
      const el = elem;
      if (direction === 'against') {
        newSpeed = -speed;
      }
      document.addEventListener('mousemove', (e) => {
        const pageX = e.clientX;
        const pageY = e.clientY;
        const style = `translateX(${pageX / newSpeed}%) translateY(${pageY / newSpeed}%)`;
        el.style.webkitTransform = style;
        el.style.transform = style;
      });
    },

    animation() {
      if (this.browser !== 'safari') {
        this.tilt();
      }
      this.parallax(this.$refs.leaf1, 100, 'against');
      this.parallax(this.$refs.leaf2, 200, 'against');
      this.parallax(this.$refs.leaf3, 300, 'against');
      this.parallax(this.$refs.elements, 500, 'against');
      this.parallax(this.$refs.elements1, 500, 'against');
      this.parallax(this.$refs.flower, 500, 'against');
      this.parallax(this.$refs.flower_two, 300);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/vars.scss";
@import "~styles/logo_animations.scss";

.logo{
  width: 100%;
  height: 100%;
  display: block;

  div{
    position: absolute;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
}

.el-wrapper{
  width: 100%;
  height: 100%;
  display: block;
  position: relative !important;
}

.element_1{
  background-image: url(/src/assets/img/logo/centre-branch-1.png);
  width: 7.96875%;
  height: 23.474178403755869%;
  left: 38.59375%;
  bottom: 26.291079812206573%;
  opacity: 0;
  transform-origin: left bottom;
}

.element_2{
  background-image: url(/src/assets/img/logo/downtown_branch.png);
  width: 22.65625%;
  height: 18.779342723004695%;
  right: 15%;
  bottom: 24.647887323943662%;
  opacity: 0;
  transform-origin: left bottom;
}

.element_3{
  background-image: url(/src/assets/img/logo/midtown_branch.png);
  width: 10%;
  height: 23.474178403755869%;
  right: 30.9375%;
  top: 33.098591549295775%;
  opacity: 0;
  transform-origin: left bottom;
}

.element_4{
  background-image: url(/src/assets/img/logo/uptown_branch.png);
  width: 10.625%;
  height: 23.004694835680751%;
  top: 11.267605633802817%;
  right: 41.875%;
  opacity: 0;
  transform-origin: left bottom;
}

.element_5{
  background-image: url(/src/assets/img/logo/leaf-3.png);
  width: 16.5625%;
  height: 30.516431924882629%;
  bottom: -1.6%;
  left: 45.1875%;
  opacity: 0;
  transform-origin: right top;
}

.element_6{
  background-image: url(/src/assets/img/logo/leaf-2.png);
  width: 7.8125%;
  height: 5.868544600938967%;
  right: 24.0625%;
  bottom: 20.657276995305164%;
  opacity: 0;
  transform-origin: left bottom;
}

.element_7{
  background-image: url(/src/assets/img/logo/leaf-1.png);
  width: 13.75%;
  height: 12.910798122065728%;
  bottom: 0.2%;
  left: 31.91625%;
  opacity: 0;
  transform-origin: right top;
}

.flower_1{
  background-image: url(/src/assets/img/logo/flower-2.png);
  width: 39.0625%;
  height: 31.924882629107981%;
  bottom: 19.309859154929577%;
  left: 28.8125%;
  transform-origin: left bottom;
  transition: all 0s;
  opacity: 0;
  transform-style: preserve-3d;
}

.flower_2{
  background-image: url(/src/assets/img/logo/flower-1.png);
  width: 55.46875%;
  height: 82.15962441314554%;
  top: 1.173708920187793%;
  right: 7.8125%;
  transform-origin: left bottom;
  opacity: 0;
  transform-style: preserve-3d;
}

.leafs{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.leaf_1{
  background-image: url(/src/assets/img/logo/fly_leaf-2.png);
  width: 13.59375%;
  height: 12.910798122065728%;
  top: 46.009389671361502%;
  left: -7.65625%;
  opacity: 0;
  transform-origin: right bottom;
}

.leaf_2{
  background-image: url(/src/assets/img/logo/fly_leaf-1.png);
  width: 7.03125%;
  height: 10.563380281690141%;
  right: -10.9375%;
  top: 56.338028169014085%;
  opacity: 0;
}

.leaf_3{
  background-image: url(/src/assets/img/logo/fly_leaf-3.png);
  width: 4.6875%;
  height: 9.389671361502347%;
  bottom: -10%;
  right: 0.625%;
  opacity: 0;
}

.letters-logo, .flower_wrapper, .leaf_wrapper{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.letters-logo_1{
  background-image: url(/src/assets/img/logo/logo-1.png);
  width: 41.40625%;
  height: 56.338028169014085%;
  left: 15.625%;
  bottom: 0px;
  opacity: 1;
  transform-style: preserve-3d;
}

.letters-logo_2{
  background-image: url(/src/assets/img/logo/logo-2.png);
  width: 63.75%;
  height: 86.854460093896714%;
  right: 12.1875%;
  top: 15.258215962441315%;
  opacity: 1;
  transform-style: preserve-3d;
}

.elements{
  position: relative !important;
  width: 100%;
  height: 100%;
  display: block;
}

.leaf_wrapper{
  z-index: 20;
}

.logo_desktop{
  width: 100%;
  height: 100%;
  display: block;
  position: relative !important;

  @media only screen and (max-width : $tablet){
    display: none;
  }
}

.logo_mobile{
  background-image: url(/src/assets/img/main.png);
  width: 100%;
  height: 100%;
  display: none;
  position: relative !important;

  @media only screen and (max-width : $tablet){
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mainpage/Logo.vue